import React, { useCallback, ReactElement } from 'react';
import LogoImage from '../../static/images/logo.svg';
import FilteredLink from '../filtered-link/filtered-link.component';
import useStylesLogo from './logo.styles';

const Logo: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const LOGO_IMAGE_WIDTH: number = 180;
  const LOGO_IMAGE_HEIGHT: number = 20;
  const LOGO_IMAGE_VIEW_BOX_WIDTH: number = 1165;
  const LOGO_IMAGE_VIEW_BOX_HEIGHT: number = 135;

  const {
    linkRoute,
    linkPermission,
    onClick,
  } = props;

  const { classes } = useStylesLogo();

  const logoImageViewBox: string = `0 0 ${LOGO_IMAGE_VIEW_BOX_WIDTH} ${LOGO_IMAGE_VIEW_BOX_HEIGHT}`;

  const onLinkClick: Function = useCallback((event: React.MouseEvent<Element, MouseEvent>): void => {
    if (onClick) {
      onClick(event);
    }
  }, []);

  return (
    <div className={classes.logo}>
      <FilteredLink link={linkRoute} permission={linkPermission} onClick={onLinkClick}>
        <LogoImage width={LOGO_IMAGE_WIDTH} height={LOGO_IMAGE_HEIGHT} viewBox={logoImageViewBox} />
      </FilteredLink>
    </div>
  );
});

export default Logo;
